import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('yahabibi_lang') || 'fr';
    } catch {
      return 'fr';
    }
  });

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'fr' ? 'en' : 'fr';
      try { localStorage.setItem('yahabibi_lang', next); } catch {}
      return next;
    });
  }, []);

  const t = useCallback((section, key) => {
    return translations[lang]?.[section]?.[key] ?? translations['fr']?.[section]?.[key] ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
